namespace PortalLibs.Shared

open System.Threading.Tasks

module Api =
  module Route =
    let prefix = "/api"
    let serverBuilder typeName methodName = $"/%s{typeName}/%s{methodName}"

    let clientBuilder typeName methodName =
      $"%s{prefix}%s{serverBuilder typeName methodName}"

  type IRemoteProtocol =
    { getUserData: unit -> Task<UserData> }
